import { render } from "./DocumentsView.vue?vue&type=template&id=6ffc096d&scoped=true"
import script from "./DocumentsView.vue?vue&type=script&lang=js"
export * from "./DocumentsView.vue?vue&type=script&lang=js"

import "./DocumentsView.vue?vue&type=style&index=0&id=6ffc096d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ffc096d"]])

export default __exports__